import Text from 'common/ui/Text';
import { Stack, Spacer } from 'common/ui/Layout';
import SettingsDropdown from 'common/SettingsDropdown';
import { SettingsMenuItem } from 'common/SettingsDropdown/SettingsDropdown';
import { useStartingImageSetting } from 'hooks/useViewerSettings';
import { useCallback } from 'react';
import { telemetryContextFor } from 'modules/Apollo/types';

export const STARTING_IMAGE_DROPDOWN = [
  { name: 'First (default)', value: 'default' },
  { name: 'Middle', value: 'middle' },
  { name: 'Last', value: 'last' },
];

export const StartingImageSettings = (): React.ReactElement => {
  const [startingImageSetting, setDefaultStartingImage] = useStartingImageSetting({
    context: APOLLO_QUERY_CONTEXT,
  });
  const handleChange = useCallback(
    async (eventValue: string) => {
      await setDefaultStartingImage(eventValue);
    },
    [setDefaultStartingImage]
  );
  return (
    <>
      <Stack alignY="center">
        <Text>Starting Image Slice</Text>
        <Spacer />
        <Stack space="small" alignY="center">
          <SettingsDropdown
            value={startingImageSetting ?? 'default'}
            onSelectedChange={(value) => {
              handleChange(String(value));
            }}
            data-testid="starting-image-preference-dropdown"
          >
            {STARTING_IMAGE_DROPDOWN.map((option) => (
              <SettingsMenuItem
                id={`starting-image-preference-menuitem-${option.value}`}
                value={option.value}
                key={option.value}
                data-testid={`${option.value}-menu-item`}
              >
                {option.name}
              </SettingsMenuItem>
            ))}
          </SettingsDropdown>
        </Stack>
      </Stack>
    </>
  );
};

StartingImageSettings.displayName = 'StartingImageSettings';

const APOLLO_QUERY_CONTEXT = telemetryContextFor(StartingImageSettings);
